import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { apiUrlComponent } from '../common/api.url.component';
import { ApiService } from '../common/API/api.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import * as XLSX from 'ts-xlsx';
import { NotifierService } from 'angular-notifier';
import { WorkBook } from 'xlsx';
import { VALID } from '@angular/forms/src/model';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { BackRestrict } from '../common/backRestrict'
import { ExcelService } from '../common/API/excel.service';

declare var config;

@Component({
  selector: 'app-phone-models',
  templateUrl: './phone-models.component.html',
  styleUrls: ['./phone-models.component.css']
})
export class PhoneModelsComponent implements OnInit {
  @ViewChild('fileUpload') fileUpload: ElementRef;
  //@ViewChild('reading_txt') reading_txt: ElementRef;
  @ViewChild('addModel') addModel: ElementRef;

  public dataSource: MatTableDataSource<DeviceInfo>;

  public ModelDetails: DeviceInfo[] = [];
  public InsertDetails: any;
  public form: FormGroup;
  public responseResult = '';
  public disabledUploadBtn: boolean;
  public arrayBuffer: any;
  public file: File;
  public excelSheetData: any[];
  public XLSX: any;
  public ExcelSheet: any;
  public DtTable: boolean;
  private DeviceColorDdlList = [];
  private StorageCapcityDdlList = [];
  private dropdownSettings = {};
  private StorageCapcityList = [];
  private OperatingSystemList = [];
  private DeviceColorList = [];
  private editForm = [];
  public searchTxt = "";
  ExcelFilterData = [];
  unsuccessdata = [];
  SuccessfullyUplodedList = [];
  AllData = [];
  onSuccess = false;
  successData = false;
  FailLogs = false;
  private readonly notifier: NotifierService;
  DeviceColor: string[];
  StorageCapcity: string[];
  StorageCapcityMeasurementUnit: string;

  ChoosefileName = 'Choose file';

  constructor(private _apiService: ApiService, private backrestrict: BackRestrict, private formbuilder: FormBuilder,
    private apiUrl: apiUrlComponent, notifierService: NotifierService, private spinner: NgxSpinnerService, private excelService: ExcelService) {

    this.form = formbuilder.group({
      DeviceBrand: ['', Validators.required],
      OperatingSystem: ['0', Validators.required],
      DeviceName: ['', Validators.required],
      //TAC: ['', Validators.required],
      InternalStorageCapacity: [''],
      //Color: [''],
    });
    this.notifier = notifierService;
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public pageSizeOptions = [5, 10, 15, 20];
  public pageSize = 10;
  public length = 10;
  public displayedColumns = ['SKUID', 'DeviceModelID', 'DeviceModelFullName', 'DeviceVendor', 'StorageCapacity'];

  applyFilter(filterValue: string) {

    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  ngOnInit() {
    this.backrestrict.clearBrowserBackHistory();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.GetModelDetails();
    this.getStorageCapacity();
  }

  getStorageCapacity() {

    this.spinner.show();
    this._apiService.get(config.WebApiPath + 'api/support-tool/GetStorageCapacity').subscribe(result => {

      if (result !== null) {
        this.spinner.hide();

        result.Table.forEach(element => {
          this.StorageCapcityDdlList.push(
            {
              item_text: element.StorageCapacity == 0 ? 'Any' : element.StorageCapacity + ' ' + element.MeasurementUnitType,
              item_id: element.StorageCapacity
            }
          )
        });

        result.Table1.forEach(element => {
          this.OperatingSystemList.push(element.DeviceOS);
        });
      }
    });
  }

  StorageCapcityonItemSelect(item: any) {
    //
    console.log(item);
    if (this.StorageCapcityList) {
      if ((this.StorageCapcityList.filter(x => x.StorageCapcity === item.item_id).length) === 0) {
        this.StorageCapcityList.push(
          {
            StorageCapcity: item.item_id
          }
        )
      }
    }
    else {
      this.StorageCapcityList = [];
      this.StorageCapcityList.push(
        {
          StorageCapcity: item.item_id
        }
      )
    }
  }

  StorageCapcityonSelectAll(items: any) {
    console.log(items);

    this.StorageCapcityList = [];
    for (var i = 0; items.length > i; i++) {
      this.StorageCapcityList.push(
        {
          StorageCapcity: items[i].item_id
        }
      )
    }

  }

  StorageCapcityonItemDeSelect(item: any) {
    this.StorageCapcityList.splice(this.StorageCapcityList.indexOf(this.StorageCapcityList.find(x => x.StorageCapcity === item.item_id)), 1);

  }
  DeviceColoronItemSelect(item: any) {
    console.log(item);
    if (this.DeviceColorList) {
      if ((this.DeviceColorList.filter(x => x.DeviceColor === item.item_id).length) === 0) {
        this.DeviceColorList.push(
          {
            DeviceColor: item.item_id
          }
        )
      }
    }
    else {
      this.DeviceColorList = [];
      this.DeviceColorList.push(
        {
          DeviceColor: item.item_id
        }
      )
    }
  }

  DeviceColoronSelectAll(items: any) {
    console.log(items);
    this.DeviceColorList = [];
    for (var i = 0; items.length > i; i++) {
      this.DeviceColorList.push(
        {
          DeviceColor: items[i].item_id
        }
      )
    }
  }

  DeviceColoronItemDeSelect(item: any) {
    this.DeviceColorList.splice(this.DeviceColorList.indexOf(this.DeviceColorList.find(x => x.DeviceColor === item.item_id)), 1);
  }



  GetModelDetails() {

    this.spinner.show();
    var _parameters = {

    }
    this._apiService.post(config.WebApiPath + 'api/support-tool/phone-model-list', _parameters).subscribe(result => {
      if (result !== null) {
        debugger;
        this.spinner.hide();
        this.ModelDetails = result.Data;
        this.dataSource = new MatTableDataSource(this.ModelDetails);
        this.dataSource.paginator = this.paginator;
      }
      else {

      }
    },
      error => {
        console.log(error);
      }
    );
  }


  // ---------------export Excel-----------------

  emptyform() {
    this.excelSheetData = null;
    this.fileUpload.nativeElement.value = '';
    //this.reading_txt.nativeElement.value = '';
    this.ChoosefileName = 'Choose file';
    this.DtTable = false;
    this.responseResult = '';
    this.disabledUploadBtn = true;
    this.form.reset();
    this.form.controls['OperatingSystem'].setValue('0');
    this.onSuccess = false;
  }

  onFileChanged(event) {

    this.ExcelSheet = event.target.files[0];
    if (event.target.files.length < 1) {
      this.disabledUploadBtn = true;
      this.responseResult = '';
      this.ChoosefileName = 'Choose file';
    }
    else {
      this.ChoosefileName = event.target.files[0].name;
      this.onSuccess = false;
      this.FailLogs = false;
      this.successData = false;
      this.getExcelFile();
    }
  }


  UploadBulk() {
    this.AllData = this.excelSheetData;
    if (this.ExcelFilterData.length > 0) {
      this._apiService.post(config.WebApiPath + 'api/support-tool/insertPhoneDetails', this.ExcelFilterData).subscribe((result: any) => {

        this.emptyform();
        this.DtTable = false;
        var jsonResult = JSON.parse(JSON.parse(result));

        this.SuccessfullyUplodedList = jsonResult.filter(item => item.Message == 'Insert SucessFully');

        var returnUnSuccessData = jsonResult.filter(item => item.Message != 'Insert SucessFully');

        returnUnSuccessData.forEach(element => {
          this.unsuccessdata.push({
            DeviceBrand: element.DeviceBrand,
            OperatingSystem: element.OperatingSystem,
            DeviceName: element.DeviceName,
            InternalStorageCapacity: element.InternalStorageCapacity,
            Response: element.Message
          })
        });



        //this.unsuccessdata.push();

        if (this.SuccessfullyUplodedList.length > 0 && this.unsuccessdata.length > 0) {
          this.notifier.notify('warning', 'Data uploaded successfully with some fail Logs');
          this.onSuccess = true;
          this.successData = true;
          this.FailLogs = true;
        }
        else if (this.SuccessfullyUplodedList.length > 0) {
          this.notifier.notify('success', 'Data uploaded successfully');
          this.onSuccess = true;
          this.GetModelDetails();
          this.notifier.notify('success', ' Data Uploaded Successfully');
          this.successData = true;
        }
        else if (this.unsuccessdata.length > 0) {
          this.notifier.notify('warning', 'Price not uploaded  with some fail Logs');
          this.FailLogs = true;
          this.onSuccess = true;
        }
        // if (jsonResult.Message === 'Insert SucessFully') {
        //   this.onSuccess = true;
        //   this.disabledUploadBtn = true;
        //   this.DtTable = false;
        //   this.form.reset();
        //   this.GetModelDetails();
        //   this.notifier.notify('success', ' Data Uploaded Successfully');
        //   this.successData = true;
        //   if (this.unsuccessdata.length) {
        //     this.FailLogs = true;
        //   }
        // }
        // else if (jsonResult.Message === 'Already exists!') {
        //   this.disabledUploadBtn = true;
        //   this.DtTable = false;
        //   this.form.reset();
        //   this.notifier.notify('warning', ' Device already exists');
        // }
        else {
          this.disabledUploadBtn = true;
          this.DtTable = false;
          this.responseResult = 'error';
          this.notifier.notify('error', 'An error occurred');
        }
        this.disabledUploadBtn = true;
        this.DtTable = false;
        this.form.reset();
      },
        error => {
          console.log(error);
          this.disabledUploadBtn = true;
          this.notifier.notify('error', error);
        })
    }
    else {
      if (this.unsuccessdata.length > 0) {
        this.onSuccess = true;
        this.FailLogs = true;        
        this.disabledUploadBtn = true;
        this.DtTable = false;
        this.form.reset();
        this.ChoosefileName = 'Choose file';
        this.notifier.notify('warning', 'Price not uploaded  with some fail Logs');
      }
    }



  }

  exportSuccessAsXLSX() {
    this.excelService.exportAsExcelFile(this.SuccessfullyUplodedList, 'SuccessfullyUplodedList');
  }
  exportUnsuccessAsXLSX() {
    this.excelService.exportAsExcelFile(this.unsuccessdata, 'UnSuccessfullyUplodedList');
  }
  exportAllAsXLSX() {
    this.excelService.exportAsExcelFile(this.AllData, 'AllList');
  }
  makeFileRequest(url: string, params: any, files: Array<File>) {
    //
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      //
      formData.append("ExcelFile", files);


      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      xhr.send(formData);
    });
  }

  UploadSingle() {
    ;
    this.editForm = [];
    let storageLength: any = 0;
    if (this.form.value.InternalStorageCapacity !== null) {
      storageLength = this.form.value.InternalStorageCapacity.length;
    }
    var deviceBrand = this.form.value.DeviceBrand == null ? null : this.form.value.DeviceBrand.trim();
    var deviceName = this.form.value.DeviceName == null ? null : this.form.value.DeviceName.trim();
    var operatingSystem = this.form.value.OperatingSystem;

    if (this.form.valid && operatingSystem != '0' && deviceBrand != '' && deviceName != '') {
      if (deviceBrand.indexOf(' ') === -1) {
        if (this.form.value.InternalStorageCapacity !== null && storageLength > 0) {
          for (var i = 0; this.form.value.InternalStorageCapacity.length > i; i++) {
            this.editForm.push(
              {
                DeviceBrand: deviceBrand,
                OperatingSystem: operatingSystem,
                DeviceName: deviceName,
                //TAC: this.form.value.TAC,
                InternalStorageCapacity: this.form.value.InternalStorageCapacity[i].item_id,
                //Color: null
              })
          }
        }
        else {
          this.editForm.push(
            {
              DeviceBrand: deviceBrand,
              OperatingSystem: operatingSystem,
              DeviceName: deviceName,
              //TAC: this.form.value.TAC,
              InternalStorageCapacity: '0',
              //Color: this.form.value.Color
            }
          )
        }
        this.emptyform();

        this._apiService.post(config.WebApiPath + 'api/support-tool/insertPhoneDetails', this.editForm).subscribe(response => {

          var jsonResult = JSON.parse(JSON.parse(response))[0];
          if (jsonResult.Message === 'Insert SucessFully') {
            this.disabledUploadBtn = true;
            this.GetModelDetails();
            this.notifier.notify('success', 'Device uploaded successfully');
            this.DtTable = false;
            this.excelSheetData = response.Data;

          }
          else if (jsonResult.Message === 'Already exists!') {
            this.disabledUploadBtn = true;
            this.DtTable = false;
            this.notifier.notify('warning', ' Device already exists');
          }
          else {
            this.disabledUploadBtn = true;
            this.DtTable = false;
            this.responseResult = 'error';
            this.notifier.notify('error', 'An error occurred');
          }
        },
          error => {
            console.log(error);
            this.disabledUploadBtn = true;
            this.notifier.notify('error', error);
          }
        );
      }
      else {
        this.notifier.notify('error', 'Device Brand contain spaces');
      }
    }
    else {
      this.notifier.notify('error', 'Mandatory Fields Required');
    }

  }

  downloadFile() {
    //
    let link = document.createElement("a");
    link.download = "DeviceTemplate";
    link.href = "assets/UploadDeviceDetails.xlsx";
    link.click();
  }

  getExcelFile() {

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      //
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      //
      var bstr = arr.join('');
      let workbook: WorkBook = XLSX.read(bstr, { type: 'binary' });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];

      var excel_data = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      this.excelSheetData = [];
      //

      excel_data.forEach(current_value => {
        const exceldata = {
          DeviceBrand: current_value['Device_Brand*'],
          OperatingSystem: current_value['Operating_System*'],
          DeviceName: current_value['Device_Name*'],
          //TAC: current_value['TAC'],
          InternalStorageCapacity: current_value['Internal_Storage_Capacity'],
          //Color: current_value['Color(Black/White/Any)']
        };

        this.excelSheetData.push(exceldata);
      });
      //
      debugger

      if (this.excelSheetData.length > 0) {
        if (this.excelSheetData[0].DeviceBrand != undefined) {
          console.log(this.excelSheetData[0].DeviceBrand);
          this.getFilterData();
          this.disabledUploadBtn = false;
        }
        else {
          this.notifier.notify('error', 'Excel is not in Proper Format');
          this.emptyform();
        }
        // if (this.excelSheetData[0].DeviceName === undefined) {
        //   this.DtTable = false;
        //   this.notifier.notify('error', 'Excel is not in Proper Format');
        //   this.disabledUploadBtn = true;
        //   this.emptyform();
        //   //this.responseResult = 'undefined';
        // }
        // else if (this.excelSheetData[0].DeviceBrand === undefined) {
        //   this.DtTable = false;
        //   this.notifier.notify('error', 'Excel is not in Proper Format');
        //   this.disabledUploadBtn = true;
        //   this.emptyform();
        //   //this.responseResult = 'undefined';
        // }
        // else if (this.excelSheetData[0].OperatingSystem === undefined) {
        //   this.DtTable = false;
        //   this.notifier.notify('error', 'Excel is not in Proper Format');
        //   this.disabledUploadBtn = true;
        //   this.emptyform();
        //   //this.responseResult = 'undefined';
        // }
        // else {
        //   this.DtTable = false;
        //   this.disabledUploadBtn = false;
        //   //this.responseResult = '';
        // }
      }
      else {
        this.notifier.notify('error', 'No Model Details In Excel');
        this.emptyform();
        this.disabledUploadBtn = true;
      }

      console.log(this.excelSheetData);
    }
    fileReader.readAsArrayBuffer(this.ExcelSheet);

  }

  getFilterData() {
    this.ExcelFilterData = [];
    this.unsuccessdata = [];
    this.excelSheetData.forEach(element => {
      var deviceBrand = element.DeviceBrand == undefined ? '' : element.DeviceBrand.trim();
      var operatingSystem = element.OperatingSystem == undefined ? '' : element.OperatingSystem.trim();
      var deviceName = element.DeviceName == undefined ? '' : element.DeviceName.trim();
      var internalStorageCapacity = element.InternalStorageCapacity == undefined ? '0' : element.InternalStorageCapacity;
      //#1Condition for  null or empty
      if (deviceBrand !== '' && deviceName !== '' && operatingSystem !== '' && deviceBrand.indexOf(' ') == -1) {
        this.ExcelFilterData.push(
          {
            DeviceBrand: deviceBrand,
            OperatingSystem: operatingSystem,
            DeviceName: deviceName,
            InternalStorageCapacity: internalStorageCapacity,
          });
      }
      else {
        var _ErrorMessage = '';
        if (deviceBrand.indexOf(' ') != -1) {
          _ErrorMessage = 'Error:-Device Brand contain spaces,';
        }
        if (deviceBrand == '') {
          _ErrorMessage = 'Error:-Invalid Device Brand,';
        }
        if (operatingSystem == '') {
          _ErrorMessage += ' Error:-Invalid Operating System,';
        }
        if (deviceName == '') {
          _ErrorMessage += ' Error:-Invalid Device Name,';
        }
        this.unsuccessdata.push({
          DeviceBrand: element.DeviceBrand,
          OperatingSystem: element.OperatingSystem,
          DeviceName: element.DeviceName,
          InternalStorageCapacity: internalStorageCapacity,
          Response: _ErrorMessage.substring(0, _ErrorMessage.length - 1)
        })
      }
    });
  }

}
export interface DeviceInfo {
  EnterprisePartnerID: number;
  EnterprisePartner: string;
  EnterprisePartnerCode: string;
  Enterprise: string;
}

